/**
 * Copyright (c) 2024 Spazious, Inc All Rights Reserved
 * Proprietary and confidential
 *
 * Written by Rubeniskov <ruben.lopez@spazious.com>, Fri Feb 16 2024
 */

import bs58 from 'bs58';

export const decodeBase58 = (input: string) => Buffer.from(bs58.decode(input).buffer);
export const encodeBase58 = bs58.encode;
